import { render, staticRenderFns } from "./userManage2.vue?vue&type=template&id=5a27e454&scoped=true&"
import script from "./userManage2.vue?vue&type=script&lang=js&"
export * from "./userManage2.vue?vue&type=script&lang=js&"
import style0 from "./userManage2.vue?vue&type=style&index=0&id=5a27e454&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a27e454",
  null
  
)

export default component.exports